import React from 'react'
import devCraftLogo from '../assets/img/devcraft-logo.png'
import powerAppsLogo from '../assets/img/powertools-logo.png'

const HomeFooter = () => {
  return (
    <>
    <section className='bg-white pt-4 pb-1'>
        <div className='container'>
          <div className='col-12 border-bottom pb-4 pt-1 text-center'>
            <a class="navbar-brand" href="#"><img src={powerAppsLogo} height="50px" width="auto"/></a>
          </div>
          <p className='text-center mt-4'>Copyright © 2023 DevCraft, Inc.</p>
        </div>
    </section>
    </>
  )
}

export default HomeFooter